<template lang="pug">
.resident-csv-table-component
  // テーブル
  b-table(
    :items="_value"
    :fields="fields"
    :busy="isLoading"
    sticky-header
    no-border-collapse
    table-class="basic-table"
    show-empty
  )
    // ローディング
    template(#table-busy)
      .text-center.table-loading-message
        b-spinner.spinner
        span.message.align-self-center 読込み中...
    // レコード無し
    template(#empty)
      .empty-message
        span 情報がありません

    // ヘッダー：利用者グループ
    template(#head(groupName)="data")
      .d-flex.flex-column
        span 利用者グループ
        span group_name
    // ヘッダー：部屋名
    template(#head(room)="data")
      .d-flex.flex-column
        span 部屋名
        span room_name
    // ヘッダー：利用者名
    template(#head(name)="data")
      .d-flex.flex-column
        span 利用者名
        span last_name
        span first_name
    // ヘッダー：利用者名（ふりがな）
    template(#head(kanaName)="data")
      .d-flex.flex-column
        span 利用者名（ふりがな）
        span last_kana_name
        span first_kana_name
    // ヘッダー：性別
    template(#head(gender)="data")
      .d-flex.flex-column
        span 性別
        span gendar
    // ヘッダー：生年月日
    template(#head(birthday)="data")
      .d-flex.flex-column
        span 生年月日
        span birthday
    // ヘッダー：電話番号
    template(#head(tel)="data")
      .d-flex.flex-column
        span 電話番号
        span telephone
    // ヘッダー：入所日／入所予定日
    template(#head(inDatetime)="data")
      .d-flex.flex-column
        span 入所日／入所予定日
        span in_date
        span in_time
    // ヘッダー：入所送迎時間
    template(#head(pickUpDatetime)="data")
      .d-flex.flex-column
        span 入所送迎時間
        span pick_up_time
    // ヘッダー：退所日／退所予定日
    template(#head(outDatetime)="data")
      .d-flex.flex-column
        span 退所日／退所予定日
        span out_date
        span out_time
    // ヘッダー：退所送迎時間
    template(#head(dropOffDatetime)="data")
      .d-flex.flex-column
        span 退所送迎時間
        span drop_off_time
    // ヘッダー：保険者番号
    template(#head(insuredNumber)="data")
      .d-flex.flex-column
        span 保険者番号
        span insured_number
    // ヘッダー：介護保険被保険者番号
    template(#head(careInsuranceInsuredNumber)="data")
      .d-flex.flex-column
        span 介護保険被保険者番号
        span care_insurance_insured_number

    // セル：利用者グループ
    template(#cell(groupName)="row")
      span.group-name(v-if="row.item.groupName != undefined") {{ row.item.groupName }}（{{ row.item.groupId }}）
      span.group-name.error-message(v-else) エラー
    // セル：部屋名
    template(#cell(room)="row")
      span.room(v-if="row.item.room != undefined") {{ row.item.room }}
      span.room.error-message(v-else) エラー
    // セル：利用者名（ふりがな）
    template(#cell(kanaName)="row")
      span.resident-kana-name(v-if="row.item.kanaName != undefined") {{ row.item.kanaName }}
      span.resident-kana-name.error-message(v-else) エラー
    // セル：利用者名
    template(#cell(name)="row")
      span.resident-name(v-if="row.item.name != undefined") {{ row.item.name }}
      span.resident-name.error-message(v-else) エラー
    // セル：利用者名（ふりがな）
    template(#cell(kanaName)="row")
      span.resident-kana-name(v-if="row.item.kanaName === null") －
      span.resident-kana-name(v-else-if="row.item.kanaName") {{ row.item.kanaName }}
      span.resident-kana-name.error-message(v-else) エラー
    // セル：性別
    template(#cell(gender)="row")
      span.gender(v-if="row.item.gender != undefined") {{ row.item.gender }}（{{ row.item.genderCode }}）
      span.gender.error-message(v-else) エラー
    // セル：生年月日
    template(#cell(birthday)="row")
      span.birthday(v-if="row.item.birthday === null") －
      span.birthday(v-else-if="row.item.birthday") {{ convertBirthDay(row.item.birthday) }}
      span.birthday.error-message(v-else) エラー
    // セル：電話番号
    template(#cell(tel)="row")
      span.tel(v-if="row.item.tel === null") －
      span.tel(v-else-if="row.item.tel") {{ row.item.tel }}
      span.tel.error-message(v-else) エラー
    // セル：入所日／入所予定日
    template(#cell(inDatetime)="row")
      span.tel(v-if="row.item.inDate === null && row.item.inTime === null") －
      span.tel(v-else-if="row.item.inDate && row.item.inTime") {{ convertDate(row.item.inDate) }} {{ convertTime(row.item.inTime) }}
      span.tel.error-message(v-else) エラー
    // セル：入所送迎時間
    template(#cell(pickUpDatetime)="row")
      span.tel(v-if="row.item.pickUpTime === null") －
      span.tel(v-else-if="row.item.pickUpTime") {{ convertTime(row.item.pickUpTime) }}
      span.tel.error-message(v-else) エラー
    // セル：退所日／退所予定日
    template(#cell(outDatetime)="row")
      span.tel(v-if="row.item.outDate === null && row.item.outTime === null") －
      span.tel(v-else-if="row.item.outDate && row.item.outTime") {{ convertDate(row.item.outDate) }} {{ convertTime(row.item.outTime) }}
      span.tel.error-message(v-else) エラー
    // セル：退所送迎時間
    template(#cell(dropOffDatetime)="row")
      span.tel(v-if="row.item.dropOffTime === null") －
      span.tel(v-else-if="row.item.dropOffTime") {{ convertTime(row.item.dropOffTime) }}
      span.tel.error-message(v-else) エラー
    // セル：保険者番号
    template(#cell(insuredNumber)="row")
      span.tel(v-if="row.item.insuredNumber === null") －
      span.tel(v-else-if="row.item.insuredNumber") {{ row.item.insuredNumber }}
      span.tel.error-message(v-else) エラー
    // セル：介護保険被保険者番号
    template(#cell(careInsuranceInsuredNumber)="row")
      span.tel(v-if="row.item.careInsuranceInsuredNumber === null") －
      span.tel(v-else-if="row.item.careInsuranceInsuredNumber") {{ row.item.careInsuranceInsuredNumber }}
      span.tel.error-message(v-else) エラー
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-property-decorator";

/**
 * 利用者テーブルコンポーネント
 */
@Component({})
export default class ResidentCsvTable extends Vue {
  /** 1行あたりの情報配列 */
  @Prop({ required: true })
  value!: Array<ResidentCsvTableItem>;
  /** 列名配列 */
  @Prop({ required: true })
  fields!: Array<ResidentCsvTableField>;
  /** ローディング表示可否 */
  @Prop({ required: true })
  isLoading!: boolean;

  get _value(): Array<ResidentCsvTableItem> {
    return this.value;
  }

  public convertBirthDay(date: number): string {
    const birthday: string = this.$dateUtil.convertNumberToString(date, "yyyy年mm月dd日");
    return birthday;
  }

  public convertDate(date: number): string {
    const datetime: number = Number(`${date}000000000`);
    const dateText: string = this.$dateUtil.convertNumberToString(datetime, "yyyy年mm月dd日");

    return dateText;
  }

  public convertTime(time: string): string {
    if (time.length != 5) {
      return "0" + time;
    } else {
      return time;
    }
  }
}

/** テーブルの列名の情報 */
export interface ResidentCsvTableField {
  key: string;
  label: string;
  sortable: boolean;
  sortDirection: string;
  class?: string;
}

/** テーブルの1行あたりの情報 */
export interface ResidentCsvTableItem {
  rowNo?: number;
  groupId?: number;
  groupName?: string;
  roomId?: number;
  room?: string;
  kanaName?: string | null;
  name?: string;
  genderCode?: number;
  gender?: string;
  tel?: string | null;
  birthday?: number | null;
  inDate?: number | null;
  inTime?: string | null;
  pickUpTime?: string | null;
  outDate?: number | null;
  outTime?: string | null;
  dropOffTime?: string | null;
  /** 保険者番号 */
  insuredNumber?: string | null;
  /** 介護保険被保険者番号 */
  careInsuranceInsuredNumber?: string | null;
}
</script>
